module.exports = "/_next/static/images/advantages-money-f1954430e7312f74310f93f2e0b45a8f.svg";